// src/pages/DashboardRedirect.js
import React from 'react';
import Dashboard from './Dashboard';
import AdminDashboard from './Admin/AdminDashboard';
import { useAuth } from '../context/AuthContext';

const DashboardRedirect = () => {
  const { isAdmin } = useAuth();
  return isAdmin ? <AdminDashboard /> : <Dashboard />;
};

export default DashboardRedirect;
